import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ROUTE_PATH from 'routes/config';
import { getDataRequest } from 'utils/request';
import { NoBtnModal } from 'components/Modal';
import Layout from 'layout';
import { Card, CardName, CardRowFirst } from 'components/FoldedCard/style';
import { Contents, NoBtnModalContent, MemberNoticeBox } from './style';
import { StyledReactQuill } from 'styles/StyledReactQuill';
import { useApp } from '../../../../contexts/AppContext';

const NoticeDetailPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const paramsSeq = parseInt(params.seq);
  const [data, setData] = useState({});
  const [isNoBtnModalOpen, setIsNoBtnModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { auth } = useApp();
  const isLogin = auth.authenticated;

  useEffect(() => {
    if (paramsSeq) {
      getDataRequest({
        url: `/v1/na/notice/${paramsSeq}`,
        setData: setData,
        setIsLoading: setIsLoading,
      });
    } else {
      alert('잘못된 접근 입니다.');
      window.close();
    }
  }, [paramsSeq]);

  useEffect(() => {
    if (!data?.result) {
      setIsNoBtnModalOpen(true);
    }
  }, [data]);

  const onCloseNoBtnModal = () => {
    navigate(ROUTE_PATH.serviceCenter.noticeListPage);
    setIsNoBtnModalOpen(false);
  };

  if (!data?.result && !isLoading)
    return (
      <NoBtnModal showModal={isNoBtnModalOpen} onClose={onCloseNoBtnModal}>
        <NoBtnModalContent>
          해당 공지가 존재하지 않습니다. 공지 사항 목록으로 이동합니다.
        </NoBtnModalContent>
      </NoBtnModal>
    );

  if (!isLogin && data?.result?.memberNoticeYn === 'Y')
    if (data)
      return (
        <Layout pageTitle="공지사항">
          <MemberNoticeBox>
            <p>
              이 공지는 회원 전용입니다.
              <br />
              해당 공지는 로그인한 회원만 열람할 수 있습니다.
            </p>
            <button type="button" onClick={() => navigate('/')}>
              홈으로 이동하기
            </button>
          </MemberNoticeBox>
        </Layout>
      );

  return (
    data &&
    data.result && (
      <Layout pageTitle="공지사항">
        <Card style={{ padding: '20px' }}>
          <CardName>{data.result.subject}</CardName>
          <CardRowFirst width="100%">
            {data.result.noticeCategoryNm}
            {data.result.mallNm && ` | ${data.result.mallNm} `}
            {data.result.notiPeriodStartDt &&
              ` | ${data.result.notiPeriodStartDt} `}
          </CardRowFirst>
        </Card>
        <Contents style={{ padding: '20px' }}>
          <StyledReactQuill value={data.result.contents} readOnly={true} />
        </Contents>
      </Layout>
    )
  );
};

export default NoticeDetailPage;
